import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'fs-lpr-sharing-management',
  templateUrl: './lpr-sharing-management.component.html',
  styleUrls: ['./lpr-sharing-management.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LprSharingManagementComponent {}


